export enum ORDER_STATUS {
  BUDGET = 1,
  ORDERED = 2,
  INVOICED = 3,
  CANCELLED = 4,
  INVOICE_WITH_ERROR_OR_REJECTION = 5,
  PDV_ISSUED = 6,
  PDV_ISSUED_WITH_REJECTIONS = 7,
  PDV_WITHOUT_ISSUED_INVOICE = 8,
  PDV_CANCELLED = 9,
  PDV_WITH_DISCOUNT_BLOCK = 10,
  PDV_BUDGET = 11,
}

